function calculerDureeCDD(debut, fin) {
  if (!debut || !fin) return "";

  const dateDebut = new Date(debut);
  const dateFin = new Date(fin);

  if (isNaN(dateDebut) || isNaN(dateFin) || dateFin < dateDebut) return "";

  let annees = dateFin.getFullYear() - dateDebut.getFullYear();
  let mois = dateFin.getMonth() - dateDebut.getMonth();
  let jours = dateFin.getDate() - dateDebut.getDate();

  if (jours < 0) {
    mois -= 1;
    const dernierJourMois = new Date(
      dateFin.getFullYear(),
      dateFin.getMonth(),
      0
    ).getDate();
    jours += dernierJourMois;
  }

  if (mois < 0) {
    annees -= 1;
    mois += 12;
  }

  let texte = [];
  if (annees > 0) texte.push(`${annees} an${annees > 1 ? "s" : ""}`);
  if (mois > 0) texte.push(`${mois} mois`);
  if (jours > 0) texte.push(`${jours} jour${jours > 1 ? "s" : ""}`);

  const result = texte.length > 0 ? texte.join(" et ") : "0 jour";
  console.log(`Duree CDD: ${result}`);
  return `Voici les dates restantes : ${result}`;
}

export const getInitialFormData = (
  civilite = "Monsieur",
  debut_cdd = "",
  fin_cdd = ""
) => {
  const mf = civilite === "Madame" ? "e " : " ";
  const mf2 = civilite === "Madame" ? "elle" : "il";

  const duree_cdd = calculerDureeCDD(debut_cdd, fin_cdd);

  return {
    date_jour: (() => {
      const date = new Date();
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    })(),

    civilite: "Monsieur",
    nom_salarie: "",
    mf,
    mf2,
    date_embauche: "",
    ccn: "",
    echelon_ccn: "",
    duree_cdd,
    motif_cdd: "",
    debut_cdd,
    fin_cdd,
    poste: "",
    durre_pressai: "",
    durre_pressai_cdd: "",
    date_fin_pressai: "",
    durre_renouv: "",
    lieu_travail: "",
    jour_mobilite: "",
    heure_semaine: "",
    heure_mois: "",
    remuneration: "",
    remuneration_chiffre: "",
    date_13eme_mois: "",
    dossier: "",
    dossier_dirigeant: "",
    qualite_dirigeant: "",
    montant_penalites: "",
    date_de_naissance: "",
    adresse: "",
    securtie_sociale: "",
    nationalite: "",
    lieu_de_naissance: "",
    lieu_dossier: "",
    siret_dossier: "",
    ape_dossier: "",
    // ------------ Articles ------------ //
    article0_texte: "",
    article0_texteprt1: "",
    //
    article0_texte_cdd: "",
    article0_texteprt1_cdd: "",
    article0_texteprt2_cdd: "",
    //
    article1_texte: "",
    article1_texteprt1: "",
    article1_texteprt2: "",
    //
    article2_texte: "",
    article2_texteprt1: "",
    article2_texteprt2: "",
    //
    article2_texte_tpa: "",
    article2_texteprt1_tpa: "",
    article2_texteprt2_tpa: "",
    //
    cdd_article2_texte: "",
    cdd_article2_texteprt1: "",
    cdd_article2_texteprt2: "",
    // CDD TPA
    cdd_article2_texte_tpa: "",
    cdd_article2_texteprt1_tpa: "",
    cdd_article2_texteprt2_tpa: "",
    cdd_article2_texteprt3_tpa: "",
    cdd_article2_texteprt4_tpa: "",
    cdd_article2_texteprt5_tpa: "",
    cdd_article2_texteprt6_tpa: "",
    //
    article3_texte: "",
    article3_texteprt0: "",
    article3_texteprt1: "",
    article3_texteprt2: "",
    article3_texteprt3: "",
    // CDD
    article3_texte_cdd: "",
    article3_texteprt0_cdd: "",
    article3_texteprt1_cdd: "",
    article3_texteprt2_cdd: "",
    article3_texteprt3_cdd: "",
    article3_texteprt4_cdd: "",
    //
    article4_texte: "",
    article4_texteprt1: "",
    article4_texteprt2: "",
    article4_texteprt3: "",
    //
    article4_texte_cdd: "",
    //
    article5_texte: "",
    //
    article6_texte: "",
    article6_texteprt1: "",
    //
    article6_texteBTP: "",
    article6_texteprt1BTP: "",
    //
    article7_texte: "",
    article7_texteprt1: "",
    article7_texteprt2: "",
    //
    article8_texte: "",
    article8_texteprt1: "",
    article8_texteprt2: "",
    article8_texteprt3: "",
    //
    article8_texte_tpa: "",
    article8_texteprt1_tpa: "",
    article8_texteprt2_tpa: "",
    //
    article9_texte: "",
    article9_texteprt1: "",
    article9_texteprt2: "",
    //
    article9_texteBTP: "",
    article9_texteprt1BTP: "",
    article9_texteprt2BTP: "",
    //
    article10_texte: "",
    article10_texteprt1: "",
    article10_texteprt2: "",
    article10_texteprt3: "",
    //
    // CDD
    article10_texte_cdd: "",
    //
    article11_texte: "",
    article11_texteprt1: "",
    article11_texteprt2: "",
    // BTP
    article11_texteBTP: "",
    article11_texteprt1BTP: "",
    article11_texteprt2BTP: "",
    article11_texteprt3BTP: "",
    article11_texteprt4BTP: "",
    //
    article12_texte: "",
    //
    article13_texte: "",
    //
    article14_texteprt1: "",
    article14_texteprt2: "",
    //
    article15_texte: "",
    article15_texteprt1: "",
    article15_texteprt2: "",
    article15_texteprt3: "",
    //
    article16_texte: "",
    article16_texteprt1: "",
    article16_texteprt2: "",
    article16_texteprt3: "",
    article16_texteprt4: "",
    article16_texteprt5: "",
    article16_texteprt6: "",
    //
    article17_texte: "",
    article17_texteprt1: "",
    //
    article18_texte: "",
    article18_texteprt1: "",
    article18_texteprt2: "",
    article18_texteprt3: "",
    article18_texteprt4: "",
    article18_texteprt5: "",
    article18_texteprt6: "",
    //
    article19_texte: "",
    article19_texteprt1: "",
    //
    article20_texte: "",
    article20_texteprt1: "",
    article20_texteprt2: "",
    article20_texteprt3: "",
    article20_texteprt4: "",
    article20_texteprt5: "",
    //
    article21_texte: "",
    article21_texteprt1: "",
    article21_texteprt2: "",
    article21_texteprt3: "",
    article21_texteprt4: "",
    article21_texteprt5: "",
    article21_texteprt6: "",
    article21_texteprt7: "",
    article21_texteprt8: "",
    article21_texteprt9: "",
    article21_texteprt10: "",
    article21_texteprt11: "",
    article21_texteprt12: "",
    article21_texteprt13: "",
    article21_texteprt14: "",
    article21_texteprt15: "",
    article21_texteprt16: "",
    article21_texteprt17: "",
    article21_texteprt18: "",
    //
    article22_texte: "",
    article22_texteprt1: "",
    article22_texteprt2: "",
    article22_texteprt3: "",
    article22_texteprt4: "",
    article22_texteprt5: "",
    article22_texteprt6: "",
    article22_texteprt7: "",
    article22_texteprt8: "",
    article22_texteprt9: "",
    article22_texteprt10: "",
    article22_texteprt11: "",
    article22_texteprt12: "",
    article22_texteprt13: "",
    article22_texteprt14: "",
    //
    article23_texte: "",
    article23_texteprt1: "",
    article23_texteprt2: "",
    article23_texteprt3: "",
    article23_texteprt4: "",
    article23_texteprt5: "",
    article23_texteprt6: "",
    article23_texteprt7: "",
    article23_texteprt8: "",
    article23_texteprt9: "",
    //
    article24_texte: "",
    article24_texteprt1: "",
    article24_texteprt2: "",
    article24_texteprt3: "",
    article24_texteprt4: "",
    article24_texteprt5: "",
    article24_texteprt6: "",
    article24_texteprt7: "",
    article24_texteprt8: "",
    article24_texteprt9: "",
    //
    article25_texte: "",
    article25_texteprt1: "",
    article25_texteprt2: "",
    article25_texteprt3: "",
    //
    article26_texte: "",
    article26_texteprt1: "",
    article26_texteprt2: "",
    article26_texteprt3: "",
    article26_texteprt4: "",
    article26_texteprt5: "",
    //
    article27_texte: "",
    article27_texteprt1: "",
    article27_texteprt2: "",
    article27_texteprt3: "",
    article27_texteprt4: "",
    article27_texteprt5: "",
    article27_texteprt6: "",
    //
    article28_texte: "",
    // CDD
    article28_texte_cdd: "",
  };
};

export const initialiserArticlesTexte = (form) => {
  const replaceEmpty = (value) => (value === "" ? "[MANQUANT]" : value);
  // Article 0 :  Préambule CDI
  const article0Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est engagé${replaceEmpty(
    form.mf
  )}sous contrat de travail à durée indéterminée à compter du ${replaceEmpty(
    formatDate(form.date_embauche)
  )}.`;
  const article0Defautprt1 = `La déclaration préalable à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )}, a été transmise à l’URSSAF de La Réunion, 4 Boulevard Doret CS 53001 97741 Saint-Denis Cedex 9, organisme auprès duquel la société est immatriculée.`;

  // Article 0 :  Préambule CDD
  const article0Defaut_cdd = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est engagé${replaceEmpty(
    form.mf
  )}sous contrat de travail à durée déterminée à compter du ${replaceEmpty(
    formatDate(form.debut_cdd)
  )}.`;
  const article0Defautprt1_cdd = `La déclaration préalable à l’embauche de${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} a été transmise à l’URSSAF de La Réunion, 4 Boulevard Doret CS 53001 97741 Saint-Denis Cedex 9, organisme auprès duquel la société est immatriculée.`;
  const article0Defautprt2_cdd = `Conformément à la loi du 6 janvier 1978,${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} a un droit d’accès et de rectification aux informations portées sur ce document.`;

  // Article 1 : DISPOSITIONS CONVENTIONNELLES APPLICABLES
  const article1Defaut = `A la date de sa signature, le présent contrat est régi par les dispositions conventionnel les suivantes :`;
  const article1Defautprt1 = `${replaceEmpty(form.echelon_ccn)}`;
  const article1Defautprt2 = `Le présent article ne saurait être interprété comme un engagement de l'employeur à continuer d'appliquer tout ou partie de ces dispositions après qu'un évènement quelconque (dénonciation, changement d'activité, etc.) aura remis en cause leur application dans l'entreprise.`;

  // Article 2 : ARTICLE <%ARTICLE2_NUMERO%> – EMPLOI – FONCTION
  const article2Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est employé${replaceEmpty(form.mf)}en qualité de « ${replaceEmpty(
    form.poste
  )} »,`;
  const article2Defautprt1 = `${replaceEmpty(form.echelon_ccn)}`;
  const article2Defautprt2 = `Pour une durée indéterminée, à partir du ${replaceEmpty(
    formatDate(form.date_embauche)
  )}.`;

  // CDD : Article 2 : ARTICLE <%ARTICLE2_NUMERO%> – EMPLOI – FONCTION
  const cdd_article2Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est employé${replaceEmpty(form.mf)}en qualité de « ${replaceEmpty(
    form.poste
  )} »,`;
  const cdd_article2Defautprt1 = `${replaceEmpty(form.echelon_ccn)}`;
  const cdd_article2Defautprt2 = `Pour une durée déterminée de ${replaceEmpty(
    form.duree_cdd
  )}, au motif ${replaceEmpty(form.motif_cdd)}, à partir du ${replaceEmpty(
    formatDate(form.date_embauche)
  )}, soit du ${replaceEmpty(formatDate(form.debut_cdd))} au ${replaceEmpty(
    formatDate(form.fin_cdd)
  )}`;

  // CDD Temps Partiel : Article 2 : ARTICLE <%ARTICLE2_NUMERO%> – EMPLOI – FONCTION
  const cdd_article2Defaut_tpa = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est employé${replaceEmpty(form.mf)}en qualité de « ${replaceEmpty(
    form.poste
  )} »,`;
  const cdd_article2Defautprt1_tpa = `${replaceEmpty(form.echelon_ccn)}`;
  const cdd_article2Defautprt2_tpa = `Pour une durée déterminée à temps partiel de ${replaceEmpty(
    form.duree_cdd
  )}, au motif ${replaceEmpty(form.motif_cdd)}, à partir du ${replaceEmpty(
    formatDate(form.date_embauche)
  )}, soit du ${replaceEmpty(formatDate(form.debut_cdd))} au ${replaceEmpty(
    formatDate(form.fin_cdd)
  )}`;
  const cdd_article2Defautprt3_tpa = `A ce titre, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} sera amené${replaceEmpty(
    form.mf
  )}à effectuer les tâches suivantes :`;
  const cdd_article2Defautprt4_tpa = `- `;
  const cdd_article2Defautprt5_tpa = `Cette liste est non exhaustive et comprend les activités traditionnelles de la fonction de ${replaceEmpty(
    form.poste
  )}.`;
  const cdd_article2Defautprt6_tpa = `Les fonctions confiées à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} sont par natures évolutives.`;

  // Article 2 : ARTICLE <%ARTICLE2_NUMERO%> – EMPLOI – FONCTION
  const article2Defaut_tpa = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est employé${replaceEmpty(form.mf)}en qualité de « ${replaceEmpty(
    form.poste
  )} »,`;
  const article2Defautprt1_tpa = `${replaceEmpty(form.echelon_ccn)}`;
  const article2Defautprt2_tpa = `Pour une durée indéterminée à temps partiel, à partir du ${replaceEmpty(
    formatDate(form.date_embauche)
  )}.`;

  // Article 3 : ARTICLE <%ARTICLE3_NUMERO%> – PERIODE D’ESSAI RENOUVELABLE
  const article3Defaut = `Le contrat de travail ne deviendra toutefois définitif qu’à l’issue d’une période d’essai de ${replaceEmpty(
    form.durre_pressai
  )} mois qui expirera le ${replaceEmpty(formatDate(form.date_fin_pressai))}.`;
  const article3Defautprt0 = `Cette période d'essai pourra faire l'objet d'un renouvellement pour une durée de ${replaceEmpty(
    form.durre_renouv
  )} dans les conditions prévues à l'article L 1221-21 du Code du travail et conformément aux dispositions de la convention collective applicable.`;
  const article3Defautprt1 = `Toute suspension de son exécution (maladie, congés...) en décalera d’autant le terme. Au cours de cette période, le contrat pourra être rompu par l'une ou l'autre des parties, à tout moment, sous réserve, en cas de rupture par l'employeur, du respect du délai de prévenance prévu à l'article L 1221-25 du Code du travail.`;
  const article3Defautprt2 = `Toute rupture de période d’essai, quel qu’en soit l’auteur, sera notifiée par écrit et remise en main propre contre décharge ou adressée en recommandé avec demande d’avis de réception.`;
  const article3Defautprt3 = `Au cours de la période d'essai et de son renouvellement éventuel, chacune des parties pourra mettre fin au contrat, à tout moment, sous réserve de respecter les délais de prévenance éventuellement applicables conformément à ce que prévoient les articles L 1221-25 et L 1221-26 du Code du travail.`;

  //CDD Article 3 : ARTICLE <%ARTICLE3_NUMERO%> – PERIODE D’ESSAI RENOUVELABLE
  const article3Defaut_cdd = `Le contrat de travail ne deviendra toutefois définitif qu’à l’issue d’une période d’essai de ${replaceEmpty(
    form.durre_pressai_cdd
  )} jours qui expirera le ${replaceEmpty(formatDate(form.date_fin_pressai))}.`;
  const article3Defautprt0_cdd = `Toute suspension de son exécution (maladie, congés…) en décalera d’autant le terme.`;
  const article3Defautprt1_cdd = `Au cours de cette période, le contrat pourra être rompu par l’une ou l’autre des parties, à tout moment, sous réserve, en cas de rupture par l’employeur, du respect du délai de prévenance prévu à l’article L 1221-25 du Code du travail.`;
  const article3Defautprt2_cdd = `Toute rupture de période d’essai, quel qu’en soit l’auteur, sera notifiée par écrit et remise en main propre contre décharge ou adressée en recommandé avec demande d’avis de réception.`;
  const article3Defautprt3_cdd = `Au cours de la période d'essai et de son renouvellement éventuel, chacune des parties pourra mettre fin au contrat, à tout moment, sous réserve de respecter les délais de prévenance éventuellement applicables conformément à ce que prévoient les articles L 1221-25 et L 1221-26 du Code du travail.`;
  const article3Defautprt4_cdd = `Après ce délai, le contrat de travail ne pourra être rompu avant l’échéance du terme, qu’en cas de faute grave ou de force majeure.`;

  // Article 4 : ARTICLE <%ARTICLE4_NUMERO%> – PERIODE D’ESSAI NON RENOUVELABLE
  const article4Defaut = `Le contrat de travail ne deviendra toutefois définitif qu’à l’issue d’une période d’essai de ${replaceEmpty(
    form.durre_pressai
  )} mois qui expirera le ${replaceEmpty(formatDate(form.date_fin_pressai))}.`;
  const article4Defautprt1 = `Toute suspension de son exécution (maladie, congés...) en décalera d’autant le terme. Au cours de cette période, le contrat pourra être rompu par l'une ou l'autre des parties, à tout moment, sous réserve, en cas de rupture par l'employeur, du respect du délai de prévenance prévu à l'article L 1221-25 du Code du travail.`;
  const article4Defautprt2 = `Toute rupture de période d’essai, quel qu’en soit l’auteur, sera notifiée par écrit et remise en main propre contre décharge ou adressée en recommandé avec demande d’avis de réception.`;
  const article4Defautprt3 = `Au cours de la période d'essai et de son renouvellement éventuel, chacune des parties pourra mettre fin au contrat, à tout moment, sous réserve de respecter les délais de prévenance éventuellement applicables conformément à ce que prévoient les articles L 1221-25 et L 1221-26 du Code du travail.`;

  // Article 4 CDD : ARTICLE <%ARTICLE4_NUMERO%> – PAS DE PERIODE D’ESSAI
  const article4Defaut_cdd = `Le contrat de travail n’est assorti d’aucune période d’essai.`;

  // Article 5 : ARTICLE <%ARTICLE4_NUMERO%> – PAS DE PERIODE D’ESSAI
  const article5Defaut = `Toute suspension de son exécution (maladie, congés...) en décalera d’autant le terme. Au cours de cette période, le contrat pourra être rompu par l'une ou l'autre des parties, à tout moment, sous réserve, en cas de rupture par l'employeur, du respect du délai de prévenance prévu à l'article L 1221-25 du Code du travail.`;

  // Article 6 : ARTICLE <%ARTICLE4_NUMERO%> – LIEU DE TRAVAIL
  const article6Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} sera rattaché${replaceEmpty(
    form.mf
  )}au siège de la société situé au ${replaceEmpty(
    form.lieu_travail
  )}. ${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} et sera amené${replaceEmpty(
    form.mf
  )}à se déplacer à travers toute l’Ile de la Réunion.`;
  const article6Defautprt1 = `En fonction des nécessités de service, la société se réserve le droit de demander à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} d’effectuer des déplacements temporaires n’entraînant pas de changement de résidence.`;

  // BTP : Article 6 : ARTICLE <%ARTICLE4_NUMERO%> – LIEU DE TRAVAIL
  const article6DefautBTP = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} sera rattaché${replaceEmpty(
    form.mf
  )}au siège de la société situé au ${replaceEmpty(
    form.lieu_travail
  )}. ${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} et sera amené${replaceEmpty(
    form.mf
  )}à se déplacer à travers toute l’Ile de la Réunion.`;
  const article6Defautprt1BTP = `En fonction des nécessités de service, la société se réserve le droit de demander à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} d’effectuer des déplacements temporaires n’entraînant pas de changement de résidence.`;

  // Article 7 : ARTICLE <%ARTICLE4_NUMERO%> – CLAUSE DE MOBILITE
  const article7Defaut = `Compte tenu de la nature de l’activité de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )}, l’employeur se réserve la possibilité de changer le lieu de travail dans d’autres établissements existants ou futurs de l’entreprise en cas de besoin justifié par l’intérêt de l’entreprise. Les établissements concernés sont situés dans les limites géographiques du département de La Réunion.`;
  const article7Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} accepte d’être muté${replaceEmpty(
    form.mf
  )}dans les limites géographiques précisé ci-dessus sans que cela nécessite son autorisation préalable`;
  const article7Defautprt2 = `Néanmoins, lorsqu’une mutation sera envisagée, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} sera informé ${replaceEmpty(
    form.jour_mobilite
  )} jours à l’avance.`;

  // Article 8 : ARTICLE <%ARTICLE4_NUMERO%> – – DUREE DU TRAVAIL ET HORAIRE
  const article8Defaut = `La durée du travail ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} sera de ${replaceEmpty(
    form.heure_semaine
  )} heures par semaine, soit ${replaceEmpty(
    form.heure_mois
  )} heures par mois.`;
  const article8Defautprt1 = `Cette durée sera répartie selon les horaires applicables dans l’entreprise et le planning qui lui sera communiqué par son employeur.`;
  const article8Defautprt2 = `A la demande de l’employeur et dans le respect des limites et conditions légales, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} pourra être amené${replaceEmpty(
    form.mf
  )}à effectuer des heures supplémentaires.`;
  const article8Defautprt3 = `L’horaire de travail de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} sera susceptible de modification en fonction des conditions particulières de travail (absence d’un ou plusieurs salariés, charge de travail, réorganisation des horaires collectifs de l’entreprise).`;

  // Article 8 : ARTICLE <%ARTICLE4_NUMERO%> – – DUREE DU TRAVAIL ET HORAIRE
  const article8Defaut_tpa = `La durée du travail ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} sera de ${replaceEmpty(
    form.heure_semaine
  )} heures par semaine, soit ${replaceEmpty(
    form.heure_mois
  )} heures par mois.`;
  const article8Defautprt1_tpa = `Cette durée sera répartie de la façon suivante :`;
  const article8Defautprt2_tpa = `A la demande de l’employeur, dans le respect des limites et conditions légales, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)}  pourra être amené${replaceEmpty(
    form.mf
  )}à effectuer des heures complémentaires.`;

  // Article 9 BTP: ARTICLE <%ARTICLE2_NUMERO%> – REMUNERATION
  const article9DefautBTP = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} percevra une rémunération mensuelle brute pour la durée du travail prévue au présent contrat, de ${replaceEmpty(
    form.remuneration
  )} ${replaceEmpty(form.remuneration_chiffre)} EUR.`;
  const article9Defautprt1BTP = `Conformément à la convention collective du BTP-Travaux Publics Réunion, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} percevra au titre de remboursement des frais professionnels, une prime de panier par jour réellement travaillé.`;
  const article9Defautprt2BTP = `Le calcul des cotisations sociales afférentes au salaire de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} sera opéré après application de la déduction forfaitaire spécifique de 8 % pour frais professionnels ce que ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} dûment informé${replaceEmpty(
    form.mf
  )}accepte`;

  // Article 9  : ARTICLE <%ARTICLE2_NUMERO%> – REMUNERATION
  const article9Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} bénéficiera d’une rémunération mensuelle brute de`;
  const article9Defautprt1 = `${replaceEmpty(
    form.remuneration
  )}    ${replaceEmpty(form.remuneration_chiffre)} EUR`;
  const article9Defautprt2 = `Pour ${replaceEmpty(
    form.heure_mois
  )} heures mensuelles.`;

  // Article 10 CDD : ARTICLE <%ARTICLE4_NUMERO%> – INDEMNITE DE FIN DE CONTRAT
  const article10Defaut_cdd = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} aura droit le cas échéant à une indemnité de fin de contrat égale à 10 % de la rémunération totale brute versée pendant la durée du contrat.`;

  // Article 10 : ARTICLE <%ARTICLE4_NUMERO%> – – TREIZIEME MOIS
  const article10Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} percevra une chaque année au mois de ${replaceEmpty(
    form.date_13eme_mois
  )} une gratification dite de 13e mois calculés sur la base du salaire moyen de l'année.`;
  const article10Defautprt1 = `Si le contrat est suspendu en cours d'année, pour quelque cause que ce soit, cette gratification sera calculée au prorata du temps de travail effectué, y compris les périodes assimilées à un travail effectif par le Code du travail et/ou les dispositions conventionnelles applicables.`;
  const article10Defautprt2 = `Le droit à cette gratification est subordonné à l'appartenance de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} à l'entreprise à la date du ${replaceEmpty(
    form.date_13eme_mois
  )} Si ${replaceEmpty(
    form.mf2
  )} a déjà quitté l'entreprise à cette date, ${replaceEmpty(
    form.date_13eme_mois
  )} n'a pas droit à la prime, même prorata temporis, pour l'année du départ.`;
  const article10Defautprt3 = `Etant versée au titre d'une année civile entière, cette prime n'est pas prise en compte dans la base de calcul de l'indemnité de congés payés.`;

  // Article 11 : ARTICLE <%ARTICLE2_NUMERO%> – CONGES PAYES
  const article11Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} bénéficiera d’un droit à congés payés, conformément aux dispositions légales en vigueur.`;
  const article11Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} sera soumis${replaceEmpty(
    form.mf
  )}pour la prise des congés payés aux mêmes règles que les autres salariés de l’entreprise.`;
  const article11Defautprt2 = `Les modalités de ce congé seront déterminées par accord avec la direction.`;

  // Article 11 BTP : ARTICLE <%ARTICLE2_NUMERO%> – CONGES PAYES
  const article11DefautBTP = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} bénéficiera d’un droit à congés payés, conformément aux dispositions légales en vigueur.`;
  const article11Defautprt1BTP = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} sera soumis${replaceEmpty(
    form.mf
  )}pour la prise des congés payés aux mêmes règles que les autres salariés de l’entreprise.`;
  const article11Defautprt2BTP = `Les modalités de ce congé seront déterminées par accord avec la direction, compte tenu des nécessités du service.`;
  const article11Defautprt3BTP = `Par ailleurs, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} sera affilié${replaceEmpty(
    form.mf
  )}à la Caisse de Congés BTP de la Réunion située au 43 Rue de la Boulangerie – BP 20850- 97477 Saint Denis.`;
  const article11Defautprt4BTP = `En cas de rupture du contrat de travail, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} devra se tourner vers la Caisse de Congés BTP de la Réunion, pour obtenir le paiement des indemnités compensatrices de congés payés qui lui seront dues.`;

  // Article 12 : ABSENCE
  const article12Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s’engage${replaceEmpty(
    form.mf
  )}à informer immédiatement et par tous moyens, son responsable en cas d’absence, quel qu’en soit le motif, et à produire dans les 48 heures les justificatifs appropriés.`;

  // Article 13 : RETRAITE COMPLEMENTAIRE
  const article13Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} sera affilié${replaceEmpty(
    form.mf
  )}à la caisse de retraite complémentaire obligatoire, CRC (CRR), 2 bis Ruelle Pavée BP 31071 97482 Saint Denis Cedex.`;

  // Article 14 : UTUELLE D’ENTREPRISE
  const article14Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est informé${replaceEmpty(form.mf)}qu’${replaceEmpty(
    form.mf2
  )} pourra si ${replaceEmpty(
    form.mf2
  )} le souhaite, bénéficier de la mutuelle santé souscrite par l’employeur, et prise en charge intégralement par l’entreprise.
Une proposition de mutuelle sera annexée au présent contrat.`;
  const article14Defautprt2 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} atteste sur l’honneur qu’${replaceEmpty(
    form.mf2
  )} a pris connaissance et qu’${replaceEmpty(
    form.mf2
  )} fournira à la société, au plus tard un mois après la signature des présentes, les documents requis pour son affiliation ou ceux justifiant de sa renonciation.`;

  // Article 15 : PERIODE D’ESSAI NON RENOUVELABLE
  const article15Defaut = `Afin de satisfaire à ses obligations déclaratives, la société transmet des informations nominatives auprès des organismes sociaux :`;
  const article15Defautprt1 = `A l’embauche, la société a établi la Déclaration Préalable à l’embauche auprès de l’URSSAF de la Réunion qui a transmis les informations auprès de la Caisse Primaire d’Assurance Maladie du domicile de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)}.`;
  const article15Defautprt2 = `Chaque mois, ainsi qu’à chaque évènement (arrêt de travail, fin de contrat), la société devra transmettre via le dispositif de la Déclaration Sociale Nominative (DSN) toutes les informations sociales nécessaires à l’exercice des droits de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)}.`;
  const article15Defautprt3 = `A cet effet, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} bénéficie le droit d’accès et de rectification des données à caractère personnel, conformément à la loi dite « informatique et libertés », auprès des différents organismes dont elle relève en leur adressant directement une demande (adresses disponibles sur le site dsn-info). Il convient de joindre au courrier le numéro de Sécurité Sociale, le ou les employeurs concernés par la demande et la ou les durée(s) concernée(s), ainsi qu’une photocopie d’un titre d’identité.`;

  // Article 16 : TRAITEMENT DES DONNEES PERSONNELLES
  const article16Defaut = `Dans le cadre de la gestion du personnel et aux fins du traitement de la paie, ${replaceEmpty(
    form.dossier
  )} ${replaceEmpty(form.dossier)} est conduit${replaceEmpty(
    form.mf
  )}à solliciter des données personnelles concernant ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )}. Ces données font l'objet d'un traitement par ${replaceEmpty(
    form.dossier
  )}, représentée par ${replaceEmpty(
    form.dossier_dirigeant
  )}, en sa qualité de ${replaceEmpty(
    form.qualite_dirigeant
  )} considéré comme étant le responsable de ces traitements.`;
  const article16Defautprt1 = `En signant le présent ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} autorise ${replaceEmpty(
    form.dossier
  )} à collecter, enregistrer et stocker ces données qui ne seront traitées et utilisées que dans la mesure de ce qui est nécessaire à l'exécution du contrat de travail, à l'accomplissement par la société des obligations qui lui incombent et dans la limite des délais de prescription applicables en matière sociale.`;
  const article16Defautprt2 = `Outre les services de ${replaceEmpty(
    form.dossier
  )} habilités à les traiter en raison de leur rôle, les destinataires de ces données sont strictement limités à ce jour aux organismes et personnes suivantes : URSSAF, caisse de retraite, organisme de prévoyance, service des impôts, service de médecine du travail compétents, Pôle emploi, prestataire chargé de la gestion de la paie.`;
  const article16Defautprt3 = `La gestion de la paie a été confiée à la société ALFA COMPTABILITE AUDIT, société d’expertise comptable. A cette fin l’ensemble des données nécessaires à la bonne exécution de la gestion de la paie lui sont communiquées. Dans le cadre de l'exécution de cette prestation, cette société a l'obligation de traiter les données transmises uniquement pour la seule finalité qui fait l'objet de la sous-traitance et à garantir la confidentialité et la sécurité de ces données.`;
  const article16Defautprt4 = `En application des dispositions législatives et réglementaires en vigueur et des articles 12 à 23 du règlement général sur la protection des données (RGPD) du 27 avril 2016, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} bénéficie de droits d'accès, de rectification, de portabilité et d'effacement de ses données ou de limitation de leur utilisation. Le salarié peut également, pour des motifs légitimes, s'opposer à leur traitement.`;
  const article16Defautprt5 = `Ces droits peuvent être exercés en s'adressant au représentant légal de ${replaceEmpty(
    form.dossier
  )} par lettre recommandée avec accusé de réception.`;
  const article16Defautprt6 = `En cas de difficultés liées à la gestion de ses données, le salarié a la possibilité d'introduire une réclamation auprès de la CNIL : tél : 01 53 73 22 22 - site internet : www.cnil.fr .`;

  // Article 17 : OBLIGATIONS DE LOYAUTE
  const article17Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est tenu${replaceEmpty(
    form.mf
  )}à une obligation de réserve à l'égard de la concurrence, de la clientèle, des fournisseurs et des tiers dans tout ce qui concerne l'exercice de ses fonctions.`;
  const article17Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} doit s'abstenir, pendant l'exécution de son contrat de travail, de tout acte contraire à l'intérêt de l'entreprise et notamment de toute activité concurrente, pour son propre compte ou pour le compte d'un tiers, de dénigrer les produits, services ou l'activité de l'entreprise, de détourner la clientèle et de débaucher le personnel, ces faits pouvant donner lieu à poursuites et/ou sanctions disciplinaires.`;

  // Article 18 : OBLIGATIONS DE CONFIDENTIALITE
  const article18Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} se déclare libre de tout engagement à sa date d'entrée en vigueur de son contrat. ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à observer toutes les instructions et consignes particulières de travail qui lui seront données et à respecter une stricte obligation de discrétion sur tout ce qui concerne l'activité de l'employeur et de toute autre société cliente.`;
  const article18Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s’engage formellement à ne divulguer à qui que ce soit aucune étude, projets, réalisations étudiées dans l'entreprise, soit pour le compte des clients de l'entreprise, soit pour l'entreprise elle-même, se déclarant à cet égard lié par le secret professionnel le plus absolu.`;
  const article18Defautprt2 = `De manière générale, la clause de confidentialité s'applique à l'ensemble des informations et données que ${replaceEmpty(
    form.nom_salarie
  )} est susceptible de connaître en raison de son poste au sein de l'entreprise.`;
  const article18Defautprt3 = `Il est notamment interdit d'utiliser, de transmettre ou vendre à quiconque des fichiers appartenant à la société, et ce pendant et après la relation contractuelle de travail.`;
  const article18Defautprt4 = `Cette obligation de confidentialité demeurera même après la fin du présent contrat quelle qu'en soit la cause.`;
  const article18Defautprt5 = `Toute violation de la présente clause de confidentialité rendra automatiquement le salarié redevable d'une pénalité fixée dès à présent et forfaitairement à un montant de ${replaceEmpty(
    form.montant_penalites
  )} €, pénalité due pour chaque infraction constatée.`;
  const article18Defautprt6 = `Le paiement de cette indemnité ne porte pas atteinte aux droits que la société se réserve expressément de poursuivre le salarié en remboursement pécuniaire et moral du préjudice effectivement subi.`;

  // Article 19 : EXCLUSIVITE – NON-CONCURRENCE
  const article19Defaut = `Compte tenu de ses fonctions, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à n'exercer aucune activité professionnelle complémentaire à celle qu'il exerce dans le cadre du présent contrat, sauf accord écrit et préalable de la société.`;
  const article19Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} ne pourra pas exercer à son propre compte les mêmes fonctions pour lesquelles il est employé chez ${replaceEmpty(
    form.dossier
  )} respectant ainsi le principe de non-concurrence, cela pourra être considéré comme une faute lourde.`;

  // Article 20 : AUTRES OBLIGATIONS PROFESSIONNELLES
  const article20Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à observer toutes les instructions et consignes particulières de travail qui lui seront données et à respecter une stricte obligation de discrétion sur tout ce qui concerne l'activité de la société.`;
  const article20Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} devra faire connaître à la société sans délai toute modification postérieure à son engagement qui pourrait intervenir dans son état civil, sa situation de famille, son adresse.`;
  const article20Defautprt2 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage également à respecter toutes les mesures d'hygiène et de sécurité mises en place par le droit du travail, à porter les équipements de protection mis à disposition et à informer l'employeur en cas de défaillance des équipements.`;
  const article20Defautprt3 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à exécuter son contrat de travail de bonne foi, et accepte de communiquer à son supérieur hiérarchique toutes les informations nécessaires au bon fonctionnement de l'entreprise. `;
  const article20Defautprt4 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à avoir un usage uniquement professionnel du matériel qui lui sera confié pour l'exécution de ses fonctions.`;
  const article20Defautprt5 = `Le non-respect de ses obligations sera considéré comme un manquement aux obligations professionnelles pouvant entrainer une rupture du contrat de travail.`;

  // Article 21 : UTILISATION DES OUTILS INFORMATIQUES
  const article21Defaut = `Dans le cadre de sa mission si l’employeur le juge nécessaire, celui-ci mettra à la disposition de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} un téléphone portable, un ordinateur portable ainsi que les équipements nécessaires à la réalisation de ses fonctions. Ces outils seront utilisés uniquement dans le cadre professionnel et les horaires de travail.`;
  const article21Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est responsable de l'usage qu'il fait des ressources de la société dans l'exercice de ses fonctions au sein de la société.`;
  const article21Defautprt2 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à conserver l'usage de ces ressources au cadre de son activité professionnelle ; un usage personnel des moyens de communication est admis exceptionnellement dans les limites visées ci-dessous.`;
  const article21Defautprt3 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à ne pas livrer, en aucune circonstance, à l'une des activités suivantes : charger, stocker, publier, diffuser ou distribuer, au moyen des ressources de la société, des documents, informations, images :`;
  const article21Defautprt4 = `à caractère violent, pornographique ou contraire aux bonnes mœurs, ou susceptibles de porter atteinte au respect de la personne humaine et de sa dignité ainsi qu'à la protection des mineurs ;`;
  const article21Defautprt5 = `à caractère diffamatoire et de manière générale illicite ;`;
  const article21Defautprt6 = `portant atteinte aux ressources de la société et plus particulièrement à l'intégralité et à la conservation des données de la société ;`;
  const article21Defautprt7 = `Il est interdit d'accéder à des serveurs Web traitant de ces sujets avec les risques de voir l'adresse e-mail de l'utilisation reprise par courrier de masse comportant des pièces jointes illicites. Si l'utilisateur est amené à recevoir, à son insu de tels éléments, il est tenu de les détruire aussitôt.`;
  const article21Defautprt8 = `D'une façon générale, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} s'engage à :`;
  const article21Defautprt9 = `Assurer la protection de ses informations et la sauvegarde de ses données en utilisant les différents moyens préconisés par le service informatique et en suivant les recommandations données par ce dernier ;`;
  const article21Defautprt10 = `Signaler tout incident, anomalie ou infraction qu'il pourra constater ;`;
  const article21Defautprt11 = `Ne pas apporter volontairement des perturbations au bon fonctionnement des systèmes informatiques et réseaux, que ce soit par des manipulations anormales du matériel ou par l'introduction de logiciels ou de fichiers personnels non autorisés par le service informatique ;`;
  const article21Defautprt12 = `Toujours mettre un mot de passe quand il est demandé ;`;
  const article21Defautprt13 = `Ne jamais partager ou divulguer son identifiant ou mot de passe ; `;
  const article21Defautprt14 = `Protéger spécifiquement ses fichiers confidentiels ;`;
  const article21Defautprt15 = `Utiliser un antivirus sur tout document de provenance externe à la société`;
  const article21Defautprt16 = `Des préconisations complémentaires pourront être adressées à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} par le service informatique ou la direction en fonction des nécessités d'organisation et de fonctionnement de la société.`;
  const article21Defautprt17 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} restituera le matériel, objet de la présente clause, dès la suspension de son contrat quelle que soit la cause, mais également dès la cessation effective de ses fonctions et au plus tard le dernier jour du contrat de travail, quelle que soit la cause de rupture`;

  // Article 22 : VEHICULE DE SERVICE
  const article22Defaut = `L’employeur pourra de mettre à disposition de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} un véhicule de société, à compter de son engagement soit le  ${replaceEmpty(
    formatDate(form.date_embauche)
  )}.`;
  const article22Defautprt1 = `Le véhicule, objet de la présente clause, est attribué exclusivement pour l’exercice des fonctions du salarié et ne peut donc être utilisé que pendant le temps de travail.`;
  const article22Defautprt2 = `Il est exclu l’utilisation du véhicule à titre privatif, il n’est pas autorisé dans le déplacement du trajet domicile et lieu de travail, sur des temps personnels, le week-end. En cas d’utilisation du véhicule sur le temps personnel, notamment le week-end, et en cas de détérioration du véhicule dans ces moments d’utilisation personnel, l’employeur pourra demander, aux frais du salarié ou retenu sur salaire, les réparations des dégradations engendrées par estimation des travaux par un professionnel.`;
  const article22Defautprt3 = `De même, lorsque l’exécution du contrat de travail est suspendue ou fait l’objet d’une cessation effective, le véhicule doit être restitué à l’employeur au plus tard le dernier jour du contrat de travail, quelle que soit la cause de la rupture ou de la suspension du contrat.`;
  const article22Defautprt4 = `Il en sera de même en cas d’absence et de congés du salarié.`;
  const article22Defautprt5 = `L’employeur prendra en charge les dépenses suivantes relatives à l’utilisation du véhicule soit.`;
  const article22Defautprt6 = `les assurances obligatoires et facultatives ;`;
  const article22Defautprt7 = `les réparations d’entretien ;`;
  const article22Defautprt8 = `les réparations d’entretien ;`;
  const article22Defautprt9 = `Le véhicule mis à disposition peut faire l’objet d’une géolocalisation. L’employeur s’engage à en informer le salarié si tel est le cas.`;
  const article22Defautprt10 = `Le salarié s’engage à signaler à l’employeur tout sinistre ou événement qui pourrait advenir et endommager le véhicule, et ceci dans les 24 heures, au plus, de sa survenue ou de sa découverte par le salarié.`;
  const article22Defautprt11 = `Par le présent, le salarié s’engage à utiliser ledit véhicule qu’à des fins professionnelles.`;
  const article22Defautprt12 = `Le salarié s’oblige à :`;
  const article22Defautprt13 = `une utilisation prudente du véhicule dans le strict respect du code de la route ;`;
  const article22Defautprt14 = `une utilisation respectueuse du véhicule et de sa mécanique et instruments.`;

  // Article 23 : VEHICULE DE FONCTION
  const article23Defaut = `L’employeur met à disposition de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} un véhicule de fonction, propriété de l'entreprise, à compter du <%date_embauche%>.`;
  const article23Defautprt1 = `Ce véhicule, attribué pour l'exercice de ses fonctions, pourra être utilisé à titre personnel par ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)}`;
  const article23Defautprt2 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à restituer ce véhicule au plus tard le dernier jour du contrat de travail, quelle que soit la cause de la rupture du contrat.`;
  const article23Defautprt3 = `Les frais d'essence et de garage seront remboursés sur présentation de factures à l'exclusion des frais générés par l'usage privé du véhicule qui resteront à la charge du salarié.`;
  const article23Defautprt4 = `L'usage privé de ce véhicule constitue un avantage en nature qui sera évalué à la somme forfaitaire de "Montant de l'avantage en nature (usage du véhicule)" euros et sera assujetti aux cotisations sociales.`;
  const article23Defautprt5 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à signaler à l'entreprise tout sinistre ou événement qui pourrait survenir au véhicule dans les 24 heures de la découverte.`;
  const article23Defautprt6 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à signaler immédiatement à l'entreprise tout retrait, suspension ou annulation de son permis de conduire.`;
  const article23Defautprt7 = `L’employeur prendra à sa charge les assurances obligatoires et facultatives et les réparations d'entretien.`;
  const article23Defautprt8 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} a pris connaissance du Contrat d'assurance et s'engage à se conformer aux clauses de celui-ci.`;
  const article23Defautprt9 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à veiller au bon entretien du véhicule conformément à la notice d'utilisation qui lui est fournie et à ne pas lui apporter de modification ou lui ajouter un quelconque accessoire sans autorisation expresse de l’entreprise.`;

  // Article 24 : VEHICULE DE FONCTION
  const article24Defaut = `L’employeur met à disposition de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )}, pour la durée de son contrat, un logement de fonction sis "Adresse complète du logement de fonction", se composant de "Description du logement de fonction", meublé non meublé à compter du "Date de prise de possession du logement de fonction".`;
  const article24Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à quitter le logement le dernier jour du contrat quelle que soit la cause de rupture du contrat.`;
  const article24Defautprt2 = `Ce logement est mis à sa disposition à titre gratuit.`;
  const article24Defautprt3 = `La présente mise à disposition constitue toutefois un avantage en nature qui sera évalué à la somme forfaitaire de "Montant de l'avantage en nature (logement de fonction)" euros et sera assujettie aux cotisations sociales.`;
  const article24Defautprt4 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} réglera les charges locatives et les consommations d'eau, de gaz et d'électricité.`;
  const article24Defautprt5 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à :`;
  const article24Defautprt6 = `prendre les lieux en l'état où ils se trouvent à la date d'entrée en jouissance du logement, à les entretenir et les rendre en bon état en fin d'occupation ;`;
  const article24Defautprt7 = `ne pas sous-louer tout ou partie de ces locaux ;`;
  const article24Defautprt8 = `ne pas réaliser de transformation sans autorisation expresse de la Société ;`;
  const article24Defautprt9 = `souscrire une assurance protégeant les locaux`;

  // Article 25 : CLAUSE DE CONFIDENTIALITE
  const article25Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à observer la discrétion la plus stricte sur les informations se rapportant aux activités de la Société auxquelles ${replaceEmpty(
    form.mf2
  )} aura accès à l'occasion et dans le cadre de ses fonctions.`;
  const article25Defautprt1 = `Notamment, ${replaceEmpty(
    form.mf2
  )} ne divulguera à quiconque les renseignements ou documents résultant de travaux réalisés dans l'entreprise qui sont couverts par le secret professionnel le plus strict.`;
  const article25Defautprt2 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} ne pourra, sans accord écrit de la direction, publier aucune étude sous quelque forme que ce soit portant sur des travaux ou des informations couverts par l'obligation de confidentialité.`;
  const article25Defautprt3 = `Cette obligation de confidentialité se prolongera après la cessation du Contrat de travail, quelle qu'en soit la cause.`;

  // Article 26 : CLAUSE DE DEDIT FORMATION
  const article26Defaut = `Du fait de la nature de ses fonctions, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} bénéficiera de la formation spécifique suivante : "Détailler le contenu de la formation" organisée par "Nom de l'organisme de formation" "Adresse complète de l'organisme de formation". Le montant de cette formation s'élève à "Coût de la formation" euros.`;
  const article26Defautprt1 = `Cette formation d'une durée de "Durée de la formation Par exemple : de six mois, (ou d'un an)" sera exécutée du "Date de début de la formation" au "Date de fin de la formation", période pendant laquelle ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} continuera de percevoir son salaire.`;
  const article26Defautprt2 = `Cette formation représente un coût réel pour la société de "Mentionner le coût réel de la formation pour l'employeur" euros. Ce coût excédant largement les obligations mises à la charge de la Société par la loi, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} s'engage à demeurer au sein de la Société pendant une durée "Durée pendant laquelle le salarié s'engage à rester dans la société Par exemple : d'un an, de cinq ans" à compter de la fin de sa formation, soit à compter du "Date de fin de la formation".`;
  const article26Defautprt3 = `Au cas où ${replaceEmpty(
    form.mf2
  )} serait amené${replaceEmpty(
    form.mf
  )}à quitter la Société pendant cette période de sa propre initiative, ${replaceEmpty(
    form.mf2
  )} sera tenu${replaceEmpty(
    form.mf
  )}rembourser à l’employeur les frais engagés pour sa formation, selon les modalités suivantes :`;
  const article26Defautprt4 = `"Modalités du remboursement des frais de formation Attention : Prévoir un remboursement, dégressif selon le temps passé dans la Société depuis la formation".`;
  const article26Defautprt5 = `L’employeur pourra également demander un remboursement des frais de formation suivant les modalités déterminées ci-dessus en cas de licenciement pour faute grave ou lourde.`;

  // Article 27 : CLAUSE RELATIVE AUX INVENTIONS DES SALARIES
  const article27Defaut = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} est embauché${replaceEmpty(
    form.mf
  )}en qualité de "Intitulé du poste du salarié" pour effectuer les missions suivantes : "Missions du salarié (inventions des salariés)".`;
  const article27Defautprt1 = `${replaceEmpty(form.civilite)} ${replaceEmpty(
    form.nom_salarie
  )} devra informer immédiatement son employeur de toute invention même faite en dehors de l'exécution de son Contrat de travail. ${replaceEmpty(
    form.mf2
  )} s'abstiendra de toute divulgation du contenu de l'invention jusqu'au dépôt de la demande de brevet.`;
  const article27Defautprt2 = `Tous les travaux, études, recherches effectuées pour le compte de l’employeur dans le cadre du contrat de travail seront la seule propriété de celle-ci.`;
  const article27Defautprt3 = `La propriété industrielle appartenant à l’employeur, celle-ci effectuera les formalités de dépôt de brevet ou de prise de tout autre titre qui s'avéreraient nécessaires.`;
  const article27Defautprt4 = `Le nom de ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} sera toutefois mentionné sur les demandes, sauf opposition de sa part, sans que cette mention ne lui donne aucun droit de propriété.`;
  const article27Defautprt5 = `Une rémunération supplémentaire sera versée à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} du fait de son invention dans les conditions fixées ci-après "Détailler ces conditions" par la convention collective par l'accord collectif.`;
  const article27Defautprt6 = `Tous litiges entre la Société ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} relatifs à la propriété ou à la rémunération des inventions faites par ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} seront soumis à la commission nationale des inventions de salariés ou au tribunal judiciaire.`;

  // Article 28 : ENTRETIEN PROFESSIONNEL
  const article28Defaut = `Conformément à l'article L 6315-1 du Code du travail, ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(
    form.nom_salarie
  )} bénéficiera tous les 2 ans d'un entretien professionnel consacré à l'examen de ses perspectives d'évolution professionnelle, notamment en termes de qualification et d’emploi.`;

  // Article 28 CDD: ENTRETIEN PROFESSIONNEL
  const article28Defaut_cdd = `Le contrat pourra être renouvelé dans des conditions qui feront l'objet d'un avenant soumis à ${replaceEmpty(
    form.civilite
  )} ${replaceEmpty(form.nom_salarie)} avant l'échéance du terme.`;

  // ------------------- return Articles ------------------- //
  return {
    // Article 0
    article0_texte: form.article0_texte || article0Defaut,
    article0_texteprt1: form.article0_texteprt1 || article0Defautprt1,

    // Article 0
    article0_texte_cdd: form.article0_texte_cdd || article0Defaut_cdd,
    article0_texteprt1_cdd:
      form.article0_texteprt1_cdd || article0Defautprt1_cdd,
    article0_texteprt2_cdd:
      form.article0_texteprt2_cdd || article0Defautprt2_cdd,

    // Article 1
    article1_texte: form.article1_texte || article1Defaut,
    article1_texteprt1: form.article1_texteprt1 || article1Defautprt1,
    article1_texteprt2: form.article1_texteprt2 || article1Defautprt2,
    // Article 2
    article2_texte: form.article2_texte || article2Defaut,
    article2_texteprt1: form.article2_texteprt1 || article2Defautprt1,
    article2_texteprt2: form.article2_texteprt2 || article2Defautprt2,
    // Article 2 CDD
    cdd_article2_texte: form.cdd_article2_texte || cdd_article2Defaut,
    cdd_article2_texteprt1:
      form.cdd_article2_texteprt1 || cdd_article2Defautprt1,
    cdd_article2_texteprt2:
      form.cdd_article2_texteprt2 || cdd_article2Defautprt2,
    // Article 2 CDD TPA
    cdd_article2_texte_tpa:
      form.cdd_article2_texte_tpa || cdd_article2Defaut_tpa,
    cdd_article2_texteprt1_tpa:
      form.cdd_article2_texteprt1_tpa || cdd_article2Defautprt1_tpa,
    cdd_article2_texteprt2_tpa:
      form.cdd_article2_texteprt2_tpa || cdd_article2Defautprt2_tpa,
    cdd_article2_texteprt3_tpa:
      form.cdd_article2_texteprt3_tpa || cdd_article2Defautprt3_tpa,
    cdd_article2_texteprt4_tpa:
      form.cdd_article2_texteprt4_tpa || cdd_article2Defautprt4_tpa,
    cdd_article2_texteprt5_tpa:
      form.cdd_article2_texteprt5_tpa || cdd_article2Defautprt5_tpa,
    cdd_article2_texteprt6_tpa:
      form.cdd_article2_texteprt6_tpa || cdd_article2Defautprt6_tpa,
    // Article 2
    article2_texte_tpa: form.article2_texte_tpa || article2Defaut_tpa,
    article2_texteprt1_tpa:
      form.article2_texteprt1_tpa || article2Defautprt1_tpa,
    article2_texteprt2_tpa:
      form.article2_texteprt2_tpa || article2Defautprt2_tpa,
    // Article 3
    article3_texte: form.article3_texte || article3Defaut,
    article3_texteprt0: form.article3_texteprt0 || article3Defautprt0,
    article3_texteprt1: form.article3_texteprt1 || article3Defautprt1,
    article3_texteprt2: form.article3_texteprt2 || article3Defautprt2,
    article3_texteprt3: form.article3_texteprt3 || article3Defautprt3,
    // Article 3 CDD
    article3_texte_cdd: form.article3_texte_cdd || article3Defaut_cdd,
    article3_texteprt0_cdd:
      form.article3_texteprt0_cdd || article3Defautprt0_cdd,
    article3_texteprt1_cdd:
      form.article3_texteprt1_cdd || article3Defautprt1_cdd,
    article3_texteprt2_cdd:
      form.article3_texteprt2_cdd || article3Defautprt2_cdd,
    article3_texteprt3_cdd:
      form.article3_texteprt3_cdd || article3Defautprt3_cdd,
    article3_texteprt4_cdd:
      form.article3_texteprt4_cdd || article3Defautprt4_cdd,
    // Article 4
    article4_texte: form.article4_texte || article4Defaut,
    article4_texteprt1: form.article4_texteprt1 || article4Defautprt1,
    article4_texteprt2: form.article4_texteprt2 || article4Defautprt2,
    article4_texteprt3: form.article4_texteprt3 || article4Defautprt3,
    // Article 4 CDD
    article4_texte_cdd: form.article4_texte_cdd || article4Defaut_cdd,
    // Article 5
    article5_texte: form.article5_texte || article5Defaut,
    // Article 6
    article6_texte: form.article6_texte || article6Defaut,
    article6_texteprt1: form.article6_texteprt1 || article6Defautprt1,
    // BTP : Article 6
    article6_texteBTP: form.article6_texteBTP || article6DefautBTP,
    article6_texteprt1BTP: form.article6_texteprt1BTP || article6Defautprt1BTP,
    // Article 7
    article7_texte: form.article7_texte || article7Defaut,
    article7_texteprt1: form.article7_texteprt1 || article7Defautprt1,
    article7_texteprt2: form.article7_texteprt2 || article7Defautprt2,
    // Article 8
    article8_texte: form.article8_texte || article8Defaut,
    article8_texteprt1: form.article8_texteprt1 || article8Defautprt1,
    article8_texteprt2: form.article8_texteprt2 || article8Defautprt2,
    article8_texteprt3: form.article8_texteprt3 || article8Defautprt3,
    // Article 8
    article8_texte_tpa: form.article8_texte_tpa || article8Defaut_tpa,
    article8_texteprt1_tpa:
      form.article8_texteprt1_tpa || article8Defautprt1_tpa,
    article8_texteprt2_tpa:
      form.article8_texteprt2_tpa || article8Defautprt2_tpa,
    // Article 9
    article9_texte: form.article9_texte || article9Defaut,
    article9_texteprt1: form.article9_texteprt1 || article9Defautprt1,
    article9_texteprt2: form.article9_texteprt2 || article9Defautprt2,
    // Article 9 BTP
    article9_texteBTP: form.article9_texteBTP || article9DefautBTP,
    article9_texteprt1BTP: form.article9_texteprt1BTP || article9Defautprt1BTP,
    article9_texteprt2BTP: form.article9_texteprt2BTP || article9Defautprt2BTP,
    // Article 10
    article10_texte_cdd: form.article10_texte_cdd || article10Defaut_cdd,
    // Article 10
    article10_texte: form.article10_texte || article10Defaut,
    article10_texteprt1: form.article10_texteprt1 || article10Defautprt1,
    article10_texteprt2: form.article10_texteprt2 || article10Defautprt2,
    article10_texteprt3: form.article10_texteprt3 || article10Defautprt3,
    // Article 11
    article11_texte: form.article11_texte || article11Defaut,
    article11_texteprt1: form.article11_texteprt1 || article11Defautprt1,
    article11_texteprt2: form.article11_texteprt2 || article11Defautprt2,
    // Article 11 BTP
    article11_texteBTP: form.article11_texteBTP || article11DefautBTP,
    article11_texteprt1BTP:
      form.article11_texteprt1BTP || article11Defautprt1BTP,
    article11_texteprt2BTP:
      form.article11_texteprt2BTP || article11Defautprt2BTP,
    article11_texteprt3BTP:
      form.article11_texteprt3BTP || article11Defautprt3BTP,
    article11_texteprt4BTP:
      form.article11_texteprt4BTP || article11Defautprt4BTP,
    // Article 12
    article12_texte: form.article12_texte || article12Defaut,
    // Article 13
    article13_texte: form.article13_texte || article13Defaut,
    // Article 14
    article14_texteprt1: form.article14_texteprt1 || article14Defautprt1,
    article14_texteprt2: form.article14_texteprt2 || article14Defautprt2,
    // Article 15
    article15_texte: form.article15_texte || article15Defaut,
    article15_texteprt1: form.article15_texteprt1 || article15Defautprt1,
    article15_texteprt2: form.article15_texteprt2 || article15Defautprt2,
    article15_texteprt3: form.article15_texteprt3 || article15Defautprt3,
    // Article 16
    article16_texte: form.article16_texte || article16Defaut,
    article16_texteprt1: form.article16_texteprt1 || article16Defautprt1,
    article16_texteprt2: form.article16_texteprt2 || article16Defautprt2,
    article16_texteprt3: form.article16_texteprt3 || article16Defautprt3,
    article16_texteprt4: form.article16_texteprt4 || article16Defautprt4,
    article16_texteprt5: form.article16_texteprt5 || article16Defautprt5,
    article16_texteprt6: form.article16_texteprt6 || article16Defautprt6,
    // Article 17
    article17_texte: form.article17_texte || article17Defaut,
    article17_texteprt1: form.article17_texteprt1 || article17Defautprt1,
    // Article 18
    article18_texte: form.article18_texte || article18Defaut,
    article18_texteprt1: form.article18_texteprt1 || article18Defautprt1,
    article18_texteprt2: form.article18_texteprt2 || article18Defautprt2,
    article18_texteprt3: form.article18_texteprt3 || article18Defautprt3,
    article18_texteprt4: form.article18_texteprt4 || article18Defautprt4,
    article18_texteprt5: form.article18_texteprt5 || article18Defautprt5,
    article18_texteprt6: form.article18_texteprt6 || article18Defautprt6,
    // Article 19
    article19_texte: form.article19_texte || article19Defaut,
    article19_texteprt1: form.article19_texteprt1 || article19Defautprt1,
    // Article 20
    article20_texte: form.article20_texte || article20Defaut,
    article20_texteprt1: form.article20_texteprt1 || article20Defautprt1,
    article20_texteprt2: form.article20_texteprt2 || article20Defautprt2,
    article20_texteprt3: form.article20_texteprt3 || article20Defautprt3,
    article20_texteprt4: form.article20_texteprt4 || article20Defautprt4,
    article20_texteprt5: form.article20_texteprt5 || article20Defautprt5,
    // Article 21
    article21_texte: form.article21_texte || article21Defaut,
    article21_texteprt1: form.article21_texteprt1 || article21Defautprt1,
    article21_texteprt2: form.article21_texteprt2 || article21Defautprt2,
    article21_texteprt3: form.article21_texteprt3 || article21Defautprt3,
    article21_texteprt4: form.article21_texteprt4 || article21Defautprt4,
    article21_texteprt5: form.article21_texteprt5 || article21Defautprt5,
    article21_texteprt6: form.article21_texteprt6 || article21Defautprt6,
    article21_texteprt7: form.article21_texteprt7 || article21Defautprt7,
    article21_texteprt8: form.article21_texteprt8 || article21Defautprt8,
    article21_texteprt9: form.article21_texteprt9 || article21Defautprt9,
    article21_texteprt10: form.article21_texteprt10 || article21Defautprt10,
    article21_texteprt11: form.article21_texteprt11 || article21Defautprt11,
    article21_texteprt12: form.article21_texteprt12 || article21Defautprt12,
    article21_texteprt13: form.article21_texteprt13 || article21Defautprt13,
    article21_texteprt14: form.article21_texteprt14 || article21Defautprt14,
    article21_texteprt15: form.article21_texteprt15 || article21Defautprt15,
    article21_texteprt16: form.article21_texteprt16 || article21Defautprt16,
    article21_texteprt17: form.article21_texteprt17 || article21Defautprt17,
    // Article 22
    article22_texte: form.article22_texte || article22Defaut,
    article22_texteprt1: form.article22_texteprt1 || article22Defautprt1,
    article22_texteprt2: form.article22_texteprt2 || article22Defautprt2,
    article22_texteprt3: form.article22_texteprt3 || article22Defautprt3,
    article22_texteprt4: form.article22_texteprt4 || article22Defautprt4,
    article22_texteprt5: form.article22_texteprt5 || article22Defautprt5,
    article22_texteprt6: form.article22_texteprt6 || article22Defautprt6,
    article22_texteprt7: form.article22_texteprt7 || article22Defautprt7,
    article22_texteprt8: form.article22_texteprt8 || article22Defautprt8,
    article22_texteprt9: form.article22_texteprt9 || article22Defautprt9,
    article22_texteprt10: form.article22_texteprt10 || article22Defautprt10,
    article22_texteprt11: form.article22_texteprt11 || article22Defautprt11,
    article22_texteprt12: form.article22_texteprt12 || article22Defautprt12,
    article22_texteprt13: form.article22_texteprt13 || article22Defautprt13,
    article22_texteprt14: form.article22_texteprt14 || article22Defautprt14,
    // Article 23
    article23_texte: form.article23_texte || article23Defaut,
    article23_texteprt1: form.article23_texteprt1 || article23Defautprt1,
    article23_texteprt2: form.article23_texteprt2 || article23Defautprt2,
    article23_texteprt3: form.article23_texteprt3 || article23Defautprt3,
    article23_texteprt4: form.article23_texteprt4 || article23Defautprt4,
    article23_texteprt5: form.article23_texteprt5 || article23Defautprt5,
    article23_texteprt6: form.article23_texteprt6 || article23Defautprt6,
    article23_texteprt7: form.article23_texteprt7 || article23Defautprt7,
    article23_texteprt8: form.article23_texteprt8 || article23Defautprt8,
    article23_texteprt9: form.article23_texteprt9 || article23Defautprt9,
    // Article 24
    article24_texte: form.article24_texte || article24Defaut,
    article24_texteprt1: form.article24_texteprt1 || article24Defautprt1,
    article24_texteprt2: form.article24_texteprt2 || article24Defautprt2,
    article24_texteprt3: form.article24_texteprt3 || article24Defautprt3,
    article24_texteprt4: form.article24_texteprt4 || article24Defautprt4,
    article24_texteprt5: form.article24_texteprt5 || article24Defautprt5,
    article24_texteprt6: form.article24_texteprt6 || article24Defautprt6,
    article24_texteprt7: form.article24_texteprt7 || article24Defautprt7,
    article24_texteprt8: form.article24_texteprt8 || article24Defautprt8,
    article24_texteprt9: form.article24_texteprt9 || article24Defautprt9,
    // Article 25
    article25_texte: form.article25_texte || article25Defaut,
    article25_texteprt1: form.article25_texteprt1 || article25Defautprt1,
    article25_texteprt2: form.article25_texteprt2 || article25Defautprt2,
    article25_texteprt3: form.article25_texteprt3 || article25Defautprt3,
    // Article 26
    article26_texte: form.article26_texte || article26Defaut,
    article26_texteprt1: form.article26_texteprt1 || article26Defautprt1,
    article26_texteprt2: form.article26_texteprt2 || article26Defautprt2,
    article26_texteprt3: form.article26_texteprt3 || article26Defautprt3,
    article26_texteprt4: form.article26_texteprt4 || article26Defautprt4,
    article26_texteprt5: form.article26_texteprt5 || article26Defautprt5,
    // Article 27
    article27_texte: form.article27_texte || article27Defaut,
    article27_texteprt1: form.article27_texteprt1 || article27Defautprt1,
    article27_texteprt2: form.article27_texteprt2 || article27Defautprt2,
    article27_texteprt3: form.article27_texteprt3 || article27Defautprt3,
    article27_texteprt4: form.article27_texteprt4 || article27Defautprt4,
    article27_texteprt5: form.article27_texteprt5 || article27Defautprt5,
    article27_texteprt6: form.article27_texteprt6 || article27Defautprt6,
    // Article 28
    article28_texte: form.article28_texte || article28Defaut,
    // Article 28 cdd
    article28_texte_cdd: form.article28_texte_cdd || article28Defaut_cdd,
  };
};

function formatDate(isoDate) {
  if (!isoDate) return "";
  const [year, month, day] = isoDate.split("-");
  return `${day}/${month}/${year}`;
}
